import React, { useContext, VFC } from 'react';

import ArticleBlock from '/components/ArticleBlock';
import {
  ContentColumn,
  IMAGE_SIZE,
  MediaColumn,
} from '/components/BlockColumns';
import { BlockProps, ColumnContainerJson } from '/types';
import { PresentModeContext } from '/utils/contexts';
import { filterKeynoteColumns } from '/utils/functions';

const BlockTwoImage: VFC<BlockProps> = ({
  animationEnabled,
  animationStep,
  setAnimationComplete,
  presentOption,
  blockContent,
  ...props
}) => {
  const presentMode = useContext(PresentModeContext);
  const columns = filterKeynoteColumns(
    blockContent?.columns?.list || [],
    presentMode,
    presentOption,
  );
  const animationComplete = animationStep >= columns.length;
  setAnimationComplete(animationComplete);

  return (
    <ArticleBlock
      {...props}
      blockContent={blockContent}
      hideFooter={animationEnabled && !animationComplete}
      titleCentered
      rowCenterAlign
      columnWidth={4}
      columns={columns.map(
        (column: ColumnContainerJson, columnNumber: number) => (
          <>
            {!column.hidden && column.name === 'content' && (
              <ContentColumn
                elements={column.elements}
                presentOption={presentOption}
                hide={animationEnabled && animationStep <= columnNumber}
              />
            )}
            {!column.hidden && column.name === 'media' && (
              <MediaColumn
                elements={column.elements}
                imageSize={IMAGE_SIZE.SMALL}
                presentOption={presentOption}
                hide={animationEnabled && animationStep <= columnNumber}
              />
            )}
          </>
        ),
      )}
    />
  );
};

BlockTwoImage.displayName = 'BlockTwoImage';
export default BlockTwoImage;
